<template>
  <Page>
    <SidePageColumn side="left">
      <QuickSideLinks :quick_links="quick_links"></QuickSideLinks>
      <v-divider class="mt-4"></v-divider>
      <FeaturedSidePromotions
        :page="page"
        section="left"
      ></FeaturedSidePromotions>
    </SidePageColumn>
    <CenterPageColumn :has_nav_bar="true" >
      <CenterNavbar :crumps="[]" title="Terms & Conditions" :width_class="page_info.center_width_class" ></CenterNavbar>
      <ContactPageBanner :has_nav_bar="true"  id="terms_top" bg_class="bg-0" :bg_url="bg_url"></ContactPageBanner>
      <TermsText></TermsText>
      <Footer
        :is_loading="is_loading"
        @on-hide-loader="$emit('on-hide-loader')"
        @on-show-loader="$emit('on-show-loader')"
      ></Footer>
    </CenterPageColumn>
    <SidePageColumn side="right">
      <SelfPromoAdd :page="page" section="right"></SelfPromoAdd>
      <HomeSideAdsContainer
        :page="page"
        side="right"
        :number_of_ads="3"
      ></HomeSideAdsContainer>
    </SidePageColumn>
  </Page>
</template>


<script>
import Page from "./../../components/Page";

import SidePageColumn from "./../../components/SidePageColumn";
import QuickSideLinks from "./../../components/QuickSideLinks";
import FeaturedSidePromotions from "./../../components/FeaturedSidePromotions";

import CenterPageColumn from "./../../components/CenterPageColumn";
import CenterNavbar from "./../../components/CenterNavbar";
import ContactPageBanner from "./../../components/ContactPageBanner";
import TermsText from "./../../components/TermsText";
import Footer from "./../../components/CenterFooter";

import SelfPromoAdd from "./../../components/SelfPromoAdd";
import HomeSideAdsContainer from "./../../components/HomeSideAdsContainer";

import page_info from "./../../lib/page_info";

export default {
  name: "Terms",
  components: {
    Page,

    SidePageColumn,
    QuickSideLinks,
    FeaturedSidePromotions,

    CenterPageColumn,
    CenterNavbar,
    ContactPageBanner,
    TermsText,
    Footer,

    SelfPromoAdd,
    HomeSideAdsContainer,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    }
  },
  data: () => {
    return {
      page: "terms",
      quick_links: [
        {
          text: "Introduction",
          href: "#terms_introduction",
        },
        {
          text: "Your Content",
          href: "#terms_your_content",
        },
        {
          text: "Indemnification",
          href: "#terms_indemnification",
        },
        {
          text: "Assignment",
          href: "#terms_assignment",
        }
      ],
      bg_url: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1601570320/botswana%20services/website%20assets/kanye_court_nqjdln.png",
      page_info:page_info
    };
  },
  mounted() {
    var options = {
      offset: 102,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#terms_top", options);
  }
};
</script>